import { Box, Button, Grid2 } from '@mui/material'
import React, { useState, useEffect } from 'react'
import Header from '../Header/Header'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import './CreateUser.css'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
// import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';


const drawerWidth = 260;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#10212c',
    // border: '2px solid #000',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
};


function CreateUser() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [isChecked, setIsChecked] = useState(false);
    const [open, setOpen] = useState(false);
    const [openModel2, setOpenModel2] = useState(false);
    const handleClose = () => setOpen(false);
    const [edit, setEdit] = useState([])

    const [state, setState] = useState({
        right: false,
    });

    const toggleDrawer = (anchor, open, val) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
        setEdit(val)
    };



    // Fetch data using axios inside useEffect
    const fetchData = async () => {
        try {
            const response = await axios.get('http://192.168.29.185:4500/usertab');
            setData(response.data);
            setTotalPages(Math.ceil(response.data.length / 10));
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    //pagination

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleCheckboxClick = (e) => {
        e.preventDefault(); // Prevent checkbox from checking immediately
        setOpen(true); // Show modal when checkbox is clicked
    };

    const handleConfirm = () => {
        setIsChecked(!isChecked); // Set checkbox as checked
        setOpen(false); // Close the modal
    };




    return (
        <div className='createuser'>
            <Box sx={{ display: 'flex' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { sm: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >

                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 12, xl: 12 }}>
                            <div className="custom_table">
                                <TableContainer >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell align="center">Email</TableCell>
                                                <TableCell align="center">Date</TableCell>
                                                <TableCell align="center">Kyc</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.slice((page - 1) * 10, page * 10).map((row) => (
                                                <TableRow
                                                    key={row.name}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell align="center">{row.Email}</TableCell>
                                                    <TableCell align="center">

                                                        <label class="switch">
                                                            <input type="checkbox"
                                                                checked={isChecked}
                                                                onClick={handleCheckboxClick}
                                                            />
                                                            <span class="slider"></span>
                                                        </label>
                                                    </TableCell>
                                                    <TableCell align="center">{row.kyc}</TableCell>
                                                    <TableCell align="center">

                                                        <div>
                                                            {['right'].map((anchor) => (
                                                                <React.Fragment key={anchor}>

                                                                    <div className="view-btn">
                                                                        <Button variant="contained" onClick={toggleDrawer(anchor, true, row)}>
                                                                            View
                                                                        </Button>
                                                                    </div>
                                                                    <SwipeableDrawer
                                                                        anchor={anchor}
                                                                        open={state[anchor]}
                                                                        onClose={toggleDrawer(anchor, false)}
                                                                        onOpen={toggleDrawer(anchor, true)}
                                                                        className='swipeable-drawers'
                                                                    >
                                                                        <Box
                                                                            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300 }}
                                                                            role="presentation"

                                                                        >


                                                                            <div class="textInputWrapper text-center">
                                                                                <input placeholder="Name" value={edit?.name} type="text" class="textInput" />
                                                                            </div>


                                                                            <div class="textInputWrapper text-center">
                                                                                <input placeholder="Email" value={edit?.Email} type="text" class="textInput" />
                                                                            </div>

                                                                            <div class="textInputWrapper text-center">
                                                                                <input placeholder="Kyc" value={edit?.kyc} type="text" class="textInput" />
                                                                            </div>

                                                                            <div class="textInputWrapper text-center">
                                                                                <input placeholder="Name" type="text" class="textInput" />
                                                                            </div>

                                                                            <div className="text-center save-btndiv">

                                                                                <button className='save-btn' onClick={toggleDrawer(anchor, false)}>
                                                                                    <div class="svg-wrapper-1">
                                                                                        <div class="svg-wrapper">
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                viewBox="0 0 24 24"
                                                                                                width="25"
                                                                                                height="25"
                                                                                                class="icon"
                                                                                            >
                                                                                                <path
                                                                                                    d="M22,15.04C22,17.23 20.24,19 18.07,19H5.93C3.76,19 2,17.23 2,15.04C2,13.07 3.43,11.44 5.31,11.14C5.28,11 5.27,10.86 5.27,10.71C5.27,9.33 6.38,8.2 7.76,8.2C8.37,8.2 8.94,8.43 9.37,8.8C10.14,7.05 11.13,5.44 13.91,5.44C17.28,5.44 18.87,8.06 18.87,10.83C18.87,10.94 18.87,11.06 18.86,11.17C20.65,11.54 22,13.13 22,15.04Z"
                                                                                                ></path>
                                                                                            </svg>
                                                                                        </div>
                                                                                    </div>
                                                                                    <span>Save</span>
                                                                                </button>

                                                                            </div>
                                                                        </Box>
                                                                    </SwipeableDrawer>
                                                                </React.Fragment>
                                                            ))}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination className='pagnation'
                                    count={totalPages}
                                    page={page}
                                    onChange={handlePageChange}
                                    variant="outlined"
                                    color='primary'
                                    shape="rounded" />
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
                <Modal
                    open={open}
                    // onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className='model'
                >
                    <Box sx={style}>
                        <div className="text-right close-svg">
                            <HighlightOffIcon onClick={handleClose} className='cursor' sx={{ fill: 'white' }} />
                        </div>
                        <h3 className="text-cnter dis-text"
                        >Are you sure you want to {!isChecked ? 'enable' : 'disable'} it?</h3>
                        <div className="view-btn text-center mt-10">

                            <Button variant="contained" onClick={handleConfirm}>
                                Confirm
                            </Button>
                        </div>
                    </Box>
                </Modal>

            </Box>
        </div>

    )
}

export default CreateUser
